import {View} from 'react-native';
import styled from 'styled-components';

export const Viewport = styled(View)`
    height: 100vh;
`;
